
import { Component, Vue } from "vue-property-decorator";
import { SMApp, SMDocuments } from "@/store";

const COMPANY = "Company";
const MY_PROFILE = "My Profile";

Component.registerHooks(["beforeRouteEnter", "beforeRouteLeave"]);

@Component
export default class Document extends Vue {
  unsetDocument() {
    SMDocuments.unsetCaseId();
    SMDocuments.unsetCompanyId();
    SMDocuments.unsetDocumentId();
    SMDocuments.unsetDocumentCard();
    SMDocuments.unsetChecks();
    SMDocuments.unsetSelectedChecks();
  }

  get documentId(): number {
    return Number(this.$route.params.document_id ?? 0);
  }

  get caseId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  async initDocument() {
    const { documentId, caseId, companyId } = this;

    if (!documentId) return;

    SMDocuments.setDocumentId(documentId);

    if (caseId) SMDocuments.setCaseId(caseId);

    if (companyId) SMDocuments.setCompanyId(companyId);

    if (!companyId) SMDocuments.unsetCompanyId();

    const data = await SMDocuments.fetchDocumentCard();

    if (data) {
      SMDocuments.setDocumentCard(data);
      SMDocuments.initChecks();
      SMDocuments.initSelectedChecks();
    } else {
      this.unsetDocument();
    }
  }

  async beforeRouteEnter(to: any, from: any, next: any) {
    next(async (vm: any) => {
      await vm.initDocument();
    });
  }

  async beforeRouteLeave(to: any, from: any, next: any) {
    next(async (vm: any) => {
      await vm.unsetDocument();
    });
  }

  created() {
    if (SMApp.pageTitle) return;

    if (this.$route.fullPath.includes("employee")) return SMApp.setPageTitle(MY_PROFILE);

    if (this.$route.fullPath.includes(COMPANY.toLocaleLowerCase()))
      return SMApp.setPageTitle(COMPANY);
  }
}
